import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FormPanel, FormTextField } from '@eas/common-web';

export function Fields() {
  //const { source } = useContext<DetailHandle<any>>(DetailContext);

  return (
    <>
      <FormPanel
        label={
          <FormattedMessage
            id="IP__FAQS__DETAIL__GENERAL_PANEL_TITLE"
            defaultMessage="Obecné"
          />
        }
      >
        <FormTextField
          name="identifier"
          label={
            <FormattedMessage
              id="IP__FAQS__DETAIL__FIELD_LABEL__IDENTIFIER"
              defaultMessage="Číslo"
            />
          }
          disabled={true}
        />
      </FormPanel>
    </>
  );
}
